import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OrgClass } from '../models/orgclass';
import { UserProfile } from '../models/user';
import { take, filter } from 'rxjs/operators';
import { TessEntitlement, VoucherEntitlement } from '../models/enums';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root',
})
export class ApphostService {
  private appHostRef;
  userInfo: UserProfile;
  orgClass: OrgClass;
  userEntitlements: string[];
  appConfig: any;

  constructor(
    private http: HttpClient,
    private loggingService: LoggingService,
  ) {}

  get appHost() {
    return this.appHostRef;
  }
  set appHost(appHostInstance) {
    this.appHostRef = appHostInstance;
  }

  async setUserContext() {
    const config = await (this.appHost.config as any).next((slice) => slice);
    this.appConfig = config.config['app-tess'];
    this.loggingService.log(`Config from AppHost: ${JSON.stringify(this.appConfig)}`);
    this.userEntitlements = await this.appHost.entitlements.permissions.pipe(take(1)).toPromise();
    this.userInfo = await this.appHost.user.info
      .pipe(
        filter((e: any) => e),
        take(1),
      )
      .toPromise();

    this.orgClass = (await this.appHost.entitlements.classification.pipe(take(1)).toPromise()) as OrgClass;
  }

  getUserEntitlements(): string[] {
    return this.userEntitlements;
  }

  isTessUser(): boolean {
    const userEntitlements = this.getUserEntitlements();
    const tessEntitlementValues = Object.values(TessEntitlement);
    return (
      userEntitlements?.some((entitlement) => tessEntitlementValues.includes(entitlement as TessEntitlement)) ||
      userEntitlements.includes(VoucherEntitlement.NASDAPRIV_VOUCHER)
    );
  }
}
